import React from "react";

import { Button, ButtonGroup, ButtonToolbar, Modal } from "react-bootstrap";

import { AxoLocal, Flexbox } from "../../utilities/LexUtilities";

import MitIDSignatureView from "../MitID/MitIDSignatureView";

export default class MitIDSigningModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      signerData: {}
    };
  }

  close = () => {
    this.setState({
      showModal: false,
      signerData: {}
    });

    //Necessary to reset the Easy ID session
    window.location.reload();
  };

  open = (signerData) => {
    this.setState({
      showModal: true,
      signerData,
    });
  };

  render() {
    let { guid, signerGuid, onSubmit, small } = this.props;
    let { showModal, signerData } = this.state;

    return (
      <Modal
        show={this.state.showModal}
        onHide={this.close}
        bsSize={small ? "small" : "large"}
      >
        <Modal.Header className="backgroundModalHeaderFooter" closeButton>
          <Modal.Title className="text-center">Signér dokument med MitID</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Flexbox justifyCenter>
            {showModal && (
              <MitIDSignatureView
                key={onSubmit}
                guid={guid}
                signerGuid={signerGuid}
                signerData={signerData}
                small={small}
              />
            )}
          </Flexbox>
        </Modal.Body>
        <Modal.Footer className="backgroundModalHeaderFooter">
          <ButtonToolbar>
            <ButtonGroup>
              <Button className="Lex-button-2" onClick={this.close}>
                <AxoLocal entity="axoAccounting22" defaultValue={"Fortryd"} />
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
}
